import { ActionType as ActionApiType, Status as ActionApiStatus } from '@wix/ambassador-ai-scheduling-assistant-v1-action/types';
import { ActionStatus, ActionType, isValidAction } from './Action';
const actionApiStatusToActionStatus = {
  [ActionApiStatus.UNKNOWN]: ActionStatus.UNKNOWN,
  [ActionApiStatus.PENDING_APPROVAL]: ActionStatus.PENDING_APPROVAL,
  [ActionApiStatus.IN_PROGRESS]: ActionStatus.IN_PROGRESS,
  [ActionApiStatus.ACTION_NEEDED]: ActionStatus.ACTION_NEEDED,
  [ActionApiStatus.COMPLETE]: ActionStatus.COMPLETE,
  [ActionApiStatus.CANCELED]: ActionStatus.CANCELED,
  [ActionApiStatus.INVALID]: ActionStatus.INVALID,
  [ActionApiStatus.FAILED]: ActionStatus.FAILED
};
const actionStatusToActionApiStatus = {
  [ActionStatus.UNKNOWN]: ActionApiStatus.UNKNOWN,
  [ActionStatus.PENDING_APPROVAL]: ActionApiStatus.PENDING_APPROVAL,
  [ActionStatus.IN_PROGRESS]: ActionApiStatus.IN_PROGRESS,
  [ActionStatus.ACTION_NEEDED]: ActionApiStatus.ACTION_NEEDED,
  [ActionStatus.COMPLETE]: ActionApiStatus.COMPLETE,
  [ActionStatus.CANCELED]: ActionApiStatus.CANCELED,
  [ActionStatus.INVALID]: ActionApiStatus.INVALID,
  [ActionStatus.FAILED]: ActionApiStatus.FAILED
};
const actionTypeToActionApiType = {
  [ActionType.UNKNOWN]: ActionApiType.UNKNOWN,
  [ActionType.CANCEL_MEETING]: ActionApiType.CANCEL_MEETING,
  [ActionType.CANCEL_RECURRING_SCHEDULE]: ActionApiType.CANCEL_RECURRING_SCHEDULE,
  [ActionType.CREATE_RECURRING_SCHEDULE]: ActionApiType.CREATE_RECURRING_SCHEDULE,
  [ActionType.EDIT_MEETING]: ActionApiType.EDIT_MEETING,
  [ActionType.EDIT_RECURRING_SCHEDULE]: ActionApiType.EDIT_RECURRING_SCHEDULE,
  [ActionType.SCHEDULE_MEETING]: ActionApiType.SCHEDULE_MEETING,
  [ActionType.ANNOUNCEMENT]: ActionApiType.ANNOUNCEMENT
};
const actionApiTypeToActionType = {
  [ActionApiType.UNKNOWN]: ActionType.UNKNOWN,
  [ActionApiType.CANCEL_MEETING]: ActionType.CANCEL_MEETING,
  [ActionApiType.CANCEL_RECURRING_SCHEDULE]: ActionType.CANCEL_RECURRING_SCHEDULE,
  [ActionApiType.CREATE_RECURRING_SCHEDULE]: ActionType.CREATE_RECURRING_SCHEDULE,
  [ActionApiType.EDIT_MEETING]: ActionType.EDIT_MEETING,
  [ActionApiType.EDIT_RECURRING_SCHEDULE]: ActionType.EDIT_RECURRING_SCHEDULE,
  [ActionApiType.SCHEDULE_MEETING]: ActionType.SCHEDULE_MEETING,
  [ActionApiType.ANNOUNCEMENT]: ActionType.ANNOUNCEMENT
};
export const convertActionApiStatusToActionStatus = status => {
  const convertedStatus = actionApiStatusToActionStatus[status];
  if (!convertedStatus) {
    throw new Error(`Unknown ActionApiStatus: ${status}`);
  }
  return convertedStatus;
};
export const convertActionStatusToActionApiStatus = status => {
  const convertedStatus = actionStatusToActionApiStatus[status];
  if (!convertedStatus) {
    throw new Error(`Unknown ActionStatus: ${status}`);
  }
  return convertedStatus;
};
export const convertActionApiTypeToActionType = type => {
  const convertedType = actionApiTypeToActionType[type];
  if (!convertedType) {
    throw new Error(`Unknown ActionApiType: ${type}`);
  }
  return convertedType;
};
export const convertActionTypeToActionApiType = type => {
  const convertedType = actionTypeToActionApiType[type];
  if (!convertedType) {
    throw new Error(`Unknown ActionType: ${type}`);
  }
  return convertedType;
};
export const actionToActionApiDetails = action => {
  switch (action.actionType) {
    case ActionType.SCHEDULE_MEETING:
      return {
        scheduleMeetingDetails: action.details
      };
    case ActionType.EDIT_MEETING:
      return {
        editMeetingDetails: action.details
      };
    case ActionType.CANCEL_MEETING:
      return {
        cancelMeetingDetails: action.details
      };
    case ActionType.CREATE_RECURRING_SCHEDULE:
      return {
        createRecurringScheduleDetails: action.details
      };
    case ActionType.EDIT_RECURRING_SCHEDULE:
      return {
        editRecurringScheduleDetails: action.details
      };
    case ActionType.CANCEL_RECURRING_SCHEDULE:
      return {
        cancelRecurringScheduleDetails: action.details
      };
    case ActionType.ANNOUNCEMENT:
      return {
        announcementDetails: action.details
      };
  }
};
export const actionApiToActionTypeAndDetails = actionApi => {
  switch (actionApi.actionType) {
    case ActionApiType.SCHEDULE_MEETING:
      {
        const {
          scheduleMeetingDetails
        } = actionApi;
        if (!scheduleMeetingDetails || !scheduleMeetingDetails.serviceId || !scheduleMeetingDetails.providerAppDefId) {
          throw new Error('scheduleMeetingDetails is invalid', {
            cause: {
              scheduleMeetingDetails
            }
          });
        }
        return {
          actionType: ActionType.SCHEDULE_MEETING,
          details: {
            serviceId: scheduleMeetingDetails.serviceId,
            providerAppDefId: scheduleMeetingDetails.providerAppDefId,
            scheduledAt: scheduleMeetingDetails.scheduledAt,
            meetingId: scheduleMeetingDetails.meetingId,
            participantEventId: scheduleMeetingDetails.participantEventId
          }
        };
      }
    case ActionApiType.EDIT_MEETING:
      {
        const {
          editMeetingDetails
        } = actionApi;
        if (!editMeetingDetails || !editMeetingDetails.meetingId || !editMeetingDetails.providerAppDefId || !editMeetingDetails.calendarId || !editMeetingDetails.reschedulingGuidelines) {
          throw new Error('editMeetingDetails is invalid', {
            cause: {
              editMeetingDetails
            }
          });
        }
        return {
          actionType: ActionType.EDIT_MEETING,
          details: {
            meetingId: editMeetingDetails.meetingId,
            providerAppDefId: editMeetingDetails.providerAppDefId,
            calendarId: editMeetingDetails.calendarId,
            reschedulingGuidelines: editMeetingDetails.reschedulingGuidelines,
            serviceId: editMeetingDetails.serviceId || undefined
          }
        };
      }
    case ActionApiType.CANCEL_MEETING:
      {
        const {
          cancelMeetingDetails
        } = actionApi;
        if (!cancelMeetingDetails || !cancelMeetingDetails.meetingId || !cancelMeetingDetails.providerAppDefId || !cancelMeetingDetails.calendarId) {
          throw new Error('cancelMeetingDetails is invalid', {
            cause: {
              cancelMeetingDetails
            }
          });
        }
        return {
          actionType: ActionType.CANCEL_MEETING,
          details: {
            meetingId: cancelMeetingDetails.meetingId,
            providerAppDefId: cancelMeetingDetails.providerAppDefId,
            calendarId: cancelMeetingDetails.calendarId
          }
        };
      }
    case ActionApiType.CREATE_RECURRING_SCHEDULE:
      const {
        createRecurringScheduleDetails
      } = actionApi;
      if (!createRecurringScheduleDetails || !createRecurringScheduleDetails.serviceId || !createRecurringScheduleDetails.providerAppDefId || !createRecurringScheduleDetails.frequency) {
        throw new Error('createRecurringScheduleDetails is invalid', {
          cause: {
            createRecurringScheduleDetails
          }
        });
      }
      return {
        actionType: ActionType.CREATE_RECURRING_SCHEDULE,
        details: {
          serviceId: createRecurringScheduleDetails.serviceId,
          providerAppDefId: createRecurringScheduleDetails.providerAppDefId,
          frequency: createRecurringScheduleDetails.frequency
        }
      };
    case ActionApiType.EDIT_RECURRING_SCHEDULE:
      const {
        editRecurringScheduleDetails
      } = actionApi;
      if (!editRecurringScheduleDetails || !editRecurringScheduleDetails.recurringScheduleId || !editRecurringScheduleDetails.frequency) {
        throw new Error('editRecurringScheduleDetails is invalid', {
          cause: {
            editRecurringScheduleDetails
          }
        });
      }
      return {
        actionType: ActionType.EDIT_RECURRING_SCHEDULE,
        details: {
          recurringScheduleId: editRecurringScheduleDetails.recurringScheduleId,
          frequency: editRecurringScheduleDetails.frequency
        }
      };
    case ActionApiType.CANCEL_RECURRING_SCHEDULE:
      const {
        cancelRecurringScheduleDetails
      } = actionApi;
      if (!cancelRecurringScheduleDetails || !cancelRecurringScheduleDetails.recurringScheduleId) {
        throw new Error('cancelRecurringScheduleDetails is invalid', {
          cause: {
            cancelRecurringScheduleDetails
          }
        });
      }
      return {
        actionType: ActionType.CANCEL_RECURRING_SCHEDULE,
        details: {
          recurringScheduleId: cancelRecurringScheduleDetails.recurringScheduleId
        }
      };
    case ActionApiType.ANNOUNCEMENT:
      const {
        announcementDetails
      } = actionApi;
      if (!announcementDetails || !announcementDetails.message) {
        throw new Error('announcementDetails is invalid', {
          cause: {
            announcementDetails
          }
        });
      }
      return {
        actionType: ActionType.ANNOUNCEMENT,
        details: {
          message: announcementDetails.message
        }
      };
    default:
      throw new Error(`Unknown ActionType: ${actionApi.actionType}`);
  }
};
const getActionNotes = actionApi => {
  switch (actionApi.status) {
    case ActionApiStatus.ACTION_NEEDED:
      return actionApi.actionNeededStatusNotes;
    default:
      return undefined;
  }
};
export const actionApiToActionEntity = actionApi => {
  if (!actionApi) {
    throw new Error('Invalid actionApi', {
      cause: {
        actionApi
      }
    });
  }
  const convertedAction = {
    id: actionApi.id,
    revision: actionApi.revision,
    taskId: actionApi.taskId,
    guidelines: actionApi.guidelines,
    recurringScheduleId: actionApi.recurringScheduleId,
    status: convertActionApiStatusToActionStatus(actionApi.status),
    notes: getActionNotes(actionApi),
    progressSummary: actionApi.progressSummary || null,
    ...actionApiToActionTypeAndDetails(actionApi)
  };
  if (isValidAction(convertedAction)) {
    return convertedAction;
  }
  throw new Error('Invalid action data', {
    cause: {
      convertedAction
    }
  });
};
export const actionEntityToActionApi = action => {
  return {
    id: action.id,
    revision: action.revision,
    createdDate: action.createdDate,
    updatedDate: action.updatedDate,
    taskId: action.taskId,
    guidelines: action.guidelines,
    recurringScheduleId: action.recurringScheduleId,
    status: convertActionStatusToActionApiStatus(action.status),
    actionType: convertActionTypeToActionApiType(action.actionType),
    ...actionToActionApiDetails(action)
  };
};
//# sourceMappingURL=converters.js.map